import {ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2} from '@angular/core';
import {DynamicFormService} from '../../../dynamic-form/dynamic-form.service';
import {BaseFieldComponent} from '../../base/base-field/base-field.component';
import {ImageFieldConfig} from '../image-field.config';
import {EventDispatcherService} from '../../../events/event-dispatcher.service';

@Component({
    selector: 'mydocma-form-image-field',
    templateUrl: './image-field.component.html',
    styleUrls: ['./image-field.component.scss']
})
export class ImageFieldComponent extends BaseFieldComponent<ImageFieldConfig> implements OnInit {

    public readonly staticCssClass = 'mydocma-image-field';

    public imageSource: Promise<string> | string;

    constructor(
        public readonly dynamicFormService: DynamicFormService,
        public readonly changeDetectorRef: ChangeDetectorRef,
        public readonly eventDispatcher: EventDispatcherService,
        element: ElementRef,
        renderer: Renderer2
    ) {
        super(dynamicFormService, changeDetectorRef, eventDispatcher,element,renderer);
    }

    /**
     * Lifecycle hook that is called after data-bound properties of a directive are initialized.
     */
    public async ngOnInit() {
        super.ngOnInit();

        await this.setImageSource();
    }

    public onClick() {
        if ((this.fieldWrapper.config as ImageFieldConfig).click) {
            (this.fieldWrapper.config as ImageFieldConfig).click();
        }

        this.eventDispatcher.notifyControlClick(this.fieldWrapper.config);
    }

    public async setImageSource() {
        if ((this.fieldWrapper.config as ImageFieldConfig).setSource) {
            this.imageSource = await (this.fieldWrapper.config as ImageFieldConfig).setSource();

            return;
        }

        this.imageSource = this.fieldWrapper.config.value;
    }

    public onFieldWrapperUpdated() {
        super.onFieldWrapperUpdated();

        this.setImageSource();
    }
}
